import LinkedInIcon from '@mui/icons-material/LinkedIn'
import Grid from '@mui/material/Grid2'
import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'
import * as React from 'react'

const LinkedInButton: React.FC = () => {
  return (
    <Link
      href="https://www.linkedin.com/in/erikstahlberg"
      target="_blank"
      color="inherit"
      underline="hover"
      sx={{
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
      >
        <Typography variant="caption" fontSize={10}>
          Skapad av
        </Typography>
        <Typography variant="caption" fontSize={10}>
          Erik Ståhlberg
        </Typography>
      </Grid>
      <LinkedInIcon sx={{ marginLeft: '10px' }} />
    </Link>
  )
}

export default LinkedInButton
